"use client";

import { Link, useParams, useReverse, useSearchParams } from "@rangojs/router/client";
import { routes } from "./urls.gen.js";
import type { PaginationData } from "./pagination.js";

export function PageNav({ total, page, perPage, route }: PaginationData) {
  const reverse = useReverse(routes);
  const params = useParams<{ categoryId?: string }>();
  const searchParams = useSearchParams();

  const totalPages = Math.ceil(total / perPage);
  if (totalPages <= 1) return null;

  const pageUrl = (p: number): string => {
    if (route === ".category") {
      return reverse(".category", {
        categoryId: params.categoryId!,
        page: p > 0 ? String(p) : undefined,
      });
    }
    const q = searchParams.get("q") ?? undefined;
    const sort = searchParams.get("sort") ?? undefined;
    return reverse(".search", {}, { q, sort, page: p > 0 ? p : undefined });
  };

  return (
    <nav className="mx-auto mt-8 flex max-w-7xl items-center justify-center gap-2 px-6 pb-8">
      {page > 0 && (
        <Link
          prefetch="viewport"
          to={pageUrl(page - 1)}
          prefetchKey=":source"
          className="rounded border border-slate-300 px-3 py-1 text-sm text-slate-700 hover:bg-slate-50"
        >
          Previous
        </Link>
      )}

      {Array.from({ length: totalPages }, (_, i) => (
        <Link
          key={i}
          prefetch="viewport"
          prefetchKey=":source"
          to={pageUrl(i)}
          className={
            i === page
              ? "rounded bg-slate-900 px-3 py-1 text-sm font-medium text-white"
              : "rounded border border-slate-300 px-3 py-1 text-sm text-slate-700 hover:bg-slate-50"
          }
        >
          {i + 1}
        </Link>
      ))}

      {page < totalPages - 1 && (
        <Link
          to={pageUrl(page + 1)}
          prefetchKey=":source"
          prefetch="viewport"
          className="rounded border border-slate-300 px-3 py-1 text-sm text-slate-700 hover:bg-slate-50"
        >
          Next
        </Link>
      )}
    </nav>
  );
}
